
import  Home from '../pages/Home';
import Wallet from '../pages/Wallet';
import NFTDetails from '../pages/NFTDetails';
import SellerProfile from '../pages/SellerPofile';
import Contact from '../pages/Contact';
import Create from '../pages/Create';
import EditProfile from '../pages/EditProfile';
import  Market from  '../pages/Market';
import { Navigate, Route, Routes } from 'react-router-dom';
import Footer from '../component/Footer/Footer';

function Routers () {
    return(
        <Routes>
            <Route  path='/'  element={ <Navigate to='/home' /> } />
            <Route  path='/home'  element={ <Home/> } />
            <Route  path='/market'  element={ <Market/> } />
            <Route  path='/create'  element={ <Create/> } />
            <Route  path='/contact'  element={ <Contact/> } />
            <Route  path='/edit-profile'  element={ <EditProfile/> } />
            <Route  path='/seller-profile'  element={ <SellerProfile/> } />
            <Route  path='/wallet'  element={ <Wallet/> } />
            <Route  path='/market/:id'  element={ <NFTDetails/> } />

        </Routes>
    );
}


export default Routers;
